export const useNav = () => useState<boolean>('useNav', () => true);
